var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sk-wave"},[_c('div',{staticClass:"sk-rect sk-rect-1"}),_c('div',{staticClass:"sk-rect sk-rect-2"}),_c('div',{staticClass:"sk-rect sk-rect-3"}),_c('div',{staticClass:"sk-rect sk-rect-4"}),_c('div',{staticClass:"sk-rect sk-rect-5"})])
}]

export { render, staticRenderFns }